/* eslint-disable import/prefer-default-export */
import { Layer as DeckGlLayer } from '@deck.gl/core';
import { Layer as FulcrumLayer } from '../../../models/layer';
import { convertXyzLayerToMapLayer } from './xyz-utils';
import { convertWmsLayerToMapLayer } from './wms-utils';
import { convertFulcrumTileToMapLayer } from './fulcrum-tiles-utils';
import { App } from '../../../hooks/use-app';

const layerTypeConversions = {
  xyz: convertXyzLayerToMapLayer,
  wms: convertWmsLayerToMapLayer,
  fulcrum: convertFulcrumTileToMapLayer,
  data: convertFulcrumTileToMapLayer,
};

/**
 * Converts a Fulcrum layer to a Map layer
 * @param {FulcrumLayer} fulcrumLayer The Fulcrum Layer
 * @returns {DeckGlLayer} The MapView compatible layer
 */
export function convertFulcrumLayerToMapLayer(fulcrumLayer: FulcrumLayer, app?: App): DeckGlLayer {
  if (!fulcrumLayer) {
    throw new Error('Invalid layer');
  }

  if (!fulcrumLayer.type || !layerTypeConversions[fulcrumLayer.type]) {
    throw new Error(`Unhandled conversion type: ${fulcrumLayer.type}`);
  }

  return layerTypeConversions[fulcrumLayer.type](fulcrumLayer, app);
}
